/* istanbul ignore file */
/** @deprecated MOB-231: legacy-слой старых напоминаний. Удалить отдельным тикетом вместе со старым UI. */
import client from '../client'
import ScheduleMapperLegacy from '@web/mapper/ScheduleMapperLegacy'
import HeaderMapper from '@web/mapper/HeaderMapper'
import { Schedule as ScheduleType } from '@web/store/types/modules/scheduleLegacy'

export default class ScheduleLegacy {
  static fetch () {
    return client.get('/schedule')
      .then((response) => {
        return {
          data: ScheduleMapperLegacy.toClient(response.data),
          headers: HeaderMapper.toClient(response.headers)
        }
      })
  }

  static update (schedule: Dictionary<ScheduleType>) {
    return client.put('/schedule/update', ScheduleMapperLegacy.toServer(schedule))
      .then((response) => {
        return {
          data: ScheduleMapperLegacy.toClient(response.data.repeatDays),
          headers: HeaderMapper.toClient(response.headers)
        }
      })
  }
}
